"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ethers_1 = require("ethers");
var getPositionKey = function (address, lowerTick, upperTick) {
    return ethers_1.utils.keccak256(ethers_1.utils.solidityPack(['address', 'int24', 'int24'], [address, lowerTick, upperTick]));
};
exports.default = getPositionKey;
//# sourceMappingURL=positionKey.js.map